import services from '.'
import { CreateReturnData, IData } from '../@types'
import { IModule, INewModule } from '../@types/module'
import { getAxiosErrorMessage } from '../resources'

interface LessonCreateReturnData {
  id: string
  uploadUrls: string[]
  activeIconUploadURL: string
  disableIconUploadURL: string
}

async function getAll(): Promise<Array<IModule> | undefined> {
  try {
    const modules = await services.api
      .get<IData<Array<IModule>>>('/modules')
      .then(({ data }) => data?.data)

    return modules
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByLevel(level: number): Promise<Array<IModule> | undefined> {
  try {
    const { data } = await services.api.get<IData<Array<IModule>>>(
      `/modules?level=${level}`,
    )

    return data.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByID(id?: string): Promise<IModule | undefined> {
  if (!id) return
  try {
    const modules = await services.api
      .get<IData<Array<IModule>>>(`/modules/?id=${id}`)
      .then(({ data }) => data?.data)

    return modules && modules[0]
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getUserModulesLogs(): Promise<Array<IModule> | undefined> {
  try {
    const modules = await services.api
      .get<IData<Array<IModule>>>('/modules/logs')
      .then(({ data }) => data?.data)

    return modules
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function create(data: INewModule): Promise<CreateReturnData | undefined> {
  try {
    const created = await services.api
      .post<IData<LessonCreateReturnData>>('/modules', data)
      .then(({ data }) => data?.data)

    if (created)
      return {
        id: created.id,
        videoUploadURL: '',
        uploadUrls: [created.activeIconUploadURL, created.disableIconUploadURL],
      }
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function deleteById(id: string): Promise<void> {
  try {
    await services.api.delete(`/modules/${id}`)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function updateById(
  id: string,
  data: Partial<INewModule>,
): Promise<Partial<CreateReturnData> | undefined> {
  try {
    const updatedModule = await services.api
      .put<IData<Partial<LessonCreateReturnData>>>('/modules', { id, ...data })
      .then(({ data }) => data?.data)
    if (updatedModule)
      return {
        id: updatedModule.id,
        uploadUrls: [
          updatedModule.activeIconUploadURL!,
          updatedModule.disableIconUploadURL!,
        ],
      }
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default {
  getAll,
  create,
  getByID,
  deleteById,
  updateById,
  getUserModulesLogs,
  getByLevel,
}
